import angular from 'angular';

import * as invoiceActions from '../../../store/actions/invoice';

import template from './submit-invoice.html';

import './itemize/itemize';
import './add-receipt/add-receipt';
import './submit-invoice.less';

const mapStateToScope = (state) => ({
  invoice: state.invoice,
  user: state.user.user,
  pets: state.pet.userPets,
  activeComponent: state.statsbar.activeComponent,
});

angular
  .module('myConsultApp')
  .controller(
    'submitInvoiceController',
    (
      $scope,
      $rootScope,
      $ngRedux,
      $http,
      ENV,
      IdentityService,
      $location,
    ) => {
      $scope.selectUser = (data) => {
        $scope.saveInvoiceUser(data);
        if (!$scope.isOrganizationUser) {
          $rootScope.userId = data.id;
        } else {
          $scope.setActiveUser(data);
          $scope.getUserPets($http, ENV, data.id);
        }
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, invoiceActions)($scope);

        // set fields based on submit-invoice version (admin / org user)
        $scope.isOrganizationUser = !$location.path().startsWith('/admin');
        $scope.descriptionField = $scope.isOrganizationUser
          ? ['email']
          : ['contact_information', 'email'];
        $scope.keyField = $scope.isOrganizationUser ? 'identities' : 'users';

        // check for active user and select them
        if ($scope.user.id) {
          $scope.selectUser($scope.user);
        }

        const uid = $location.search().uid;
        if (uid) {
          IdentityService.getUser(uid)
            .then((user) => {
              $scope.selectUser({ id: user.id, email: user.contact_information.email });
            })
            .catch(() => {});
        }
      };
      $scope.init();

      $scope.$on('$routeChangeStart', async () => {
        if (!$scope.isOrganizationUser) {
          $scope.invoiceClear();
        }
      });

      $scope.container_class = 'submit-invoice-container';
      $scope.currentView = 'receipt';

      // watch for user change and set state.invoice.availableClinics
      // clear invoice if user has changed
      $scope.userListener = $scope.$watch('user.id', (newValue, oldValue) => {
        if ($scope.user.id && newValue !== oldValue) {
          $scope.invoiceClear();
          $scope.saveInvoiceUser($scope.user);
          $scope.getClinicsForUser($http, ENV, $scope.user.id);
        }
        if ($scope.isOrganizationUser) {
          $scope.invoiceSetClinicsForPets($rootScope.vetOrganizations);
        }
      });

      // When we open the component set the active user on the invoice store
      $scope.$watch('activeComponent', (newValue) => {
        if (newValue === 'submit-invoice') {
          $scope.saveInvoiceUser($scope.user);
          if (!$scope.isOrganizationUser && $scope.user && $scope.user.id) {
            $scope.getClinicsForUser($http, ENV, $scope.user.id);
          }
        }
      });

      // watch properties on invoice store to check to see if user can move to itemize step
      $scope.invoiceListener = $scope.$watch('invoice', (invoiceStore) => {
        $scope.purchaseDetailsAreComplete =
          invoiceStore.clinic &&
          invoiceStore.purchaseLocation &&
          invoiceStore.datePurchased &&
          invoiceStore.receipts?.length > 0 &&
          invoiceStore.transaction_id;

        // if purchase details are not complete then return to add receipt view
        if (!$scope.purchaseDetailsAreComplete) {
          $scope.currentView = 'receipt';
        }
      });

      $scope.searchClients = (query) => {
        return $scope.getUsers($http, ENV, {
          application_subscription: 5,
          is_active: true,
          is_anonymized: false,
          autocomplete: true,
          groups: 2,
          order: 'last_name',
          search: query,
        });
      };

      $scope.searchClientsPage = (query) => {
        return $scope.getUsersByUrl($http, query);
      };

      $scope.onCloseComponent = () => {
        const isManageTransactions = $location.path().includes('manage-transactions');
        if (isManageTransactions) {
          $scope.invoiceClear();
        }
        $rootScope.closeComponent();
      };

      $scope.onCancelInvoice = () => {
        // we don't want to clear the user from the invoice on the user profile page
        const shouldClearUser = !$location.path().includes('manage-users');
        $rootScope.closeComponent();
        $scope.invoiceClear(shouldClearUser);
      };

      $scope.onChangeView = (view) => {
        if ($scope.invoice.items && $scope.invoice.items.length > 0) {
          $scope.invoiceSubmitTransaction({ $http, ENV, verify: true });
        }
        if (view === 'itemize') {
          $scope.invoiceGetProducts({ $http, ENV }).then(() => {
            $scope.currentView = view;
            $scope.$digest();
          });
        } else {
          $scope.currentView = view;
        }
      };

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.userListener();
      });
    },
  )
  .directive('submitInvoice', () => ({
    controller: 'submitInvoiceController',
    template,
  }));
